<template>
  <div id="legal-privacy">
    <v-container v-if="!$store.state.site.whitelabel">
      <v-card class="rounded-xl" elevation="7">
        <v-container>
          <p class="text-h4">
            {{ $store.state.site.name }} Privacy Policy, Last updated: 5th of
            October 2021
          </p>
          <p>
            {{ $store.state.site.name }} provides a file sharing, and hosting
            platform via our website ("Service", "Site", "Website").
          </p>
          <p class="text-h5">Information we collect and store:</p>
          <p>
            When you visit the Service, we will automatically collect some
            information about your device. This is displayed below.
          </p>
          <p class="text-h6">When you register to the Service:</p>
          <ul>
            <li>
              Your email address (This will be used for contacting you in case
              of service changes, password resets, verification and
              authentication.)
            </li>
            <li>
              Password (This is used for authentication, your password is
              automatically hashed and cannot be read by us.)
            </li>
            <li>
              Desired Username (This is used for authentication, and is your
              public name shown to others.)
            </li>
            <li>
              Account creation and updated date (This is a reference on when
              your account was created, the updated date gets updated everytime
              you make a change to your user account.)
            </li>
            <li>Which invite you used, and who invited you to the Service.</li>
          </ul>
          <p class="text-h6">When you login to the Service:</p>
          <ul>
            <li>
              Username (This is used for authentication. Only collected from you
              if you login with your username.)
            </li>
            <li>
              Email (This is used for authentication. Only collected from you if
              you login with your email.)
            </li>
            <li>
              One-Time 2FA TOTP Code (This is used for authentication. Only
              collected from you if you have TOTP enabled.)
            </li>
            <li>Password (This is used for authentication.)</li>
          </ul>
          <p class="text-h5">Where your data is processed:</p>
          <p>
            Your data is processed in servers in the United States. Regardless
            of your location, you agree to the data sent to the Service to be
            processed in these regions.
          </p>
          <p class="text-h5">Third-Party Content and Websites:</p>
          <p>
            This privacy policy does not effect any third party websites that
            may be linked on our Service, we recommend reading the Privacy
            Policy of the third-party, if we link to content on third-parties
            this does not mean we endorse the third-party.
          </p>
          <p class="text-h5">Cloudflare:</p>
          <p>
            We use Cloudflare to provide protection and mitigation against
            Denial of Service (DDoS) and Distributed Denial of Service (DDoS)
            attacks, Cloudflare has their own Privacy Policy that we recommend
            you read
            <a href="https://www.cloudflare.com/privacypolicy/">here</a>.
          </p>
          <p class="text-h5">Underaged Users:</p>
          <p>
            The Service is for users over the age of 13, we never knowingly
            collect, or process data from children under the age of 13, if you
            are a parent or legal guardian of a child under the age of 13, and
            believe they have published personal information on our Service,
            please contact us at
            <a href="mailto:contact@jays.host">this email address</a>.
            <br /><br />
            If you are a resident of a country where the age of digital consent
            is over 13, you must be over the minimum age of digital consent to
            access our Service. We never knowingly process information/data for
            users under this age of digital consent. If we discover we are or
            have processed data for such users, we will immediately take actions
            to remove them from our servers and cease processing of this data.
          </p>
          <p class="text-h5">Changes to our Privacy Policy:</p>
          <p>
            We have the right to change our Privacy Policy at anytime without
            notification to the user. We will notify the user of any significant
            changes to our Privacy Policy via the email linked to their account.
          </p>
          <p class="text-h5">Questions?</p>
          <p>
            If you have any questions about our Privacy Policy or Terms of
            Service, please reach us at
            <a href="mailto:contact@jays.host">this email address</a>.
          </p>
        </v-container>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "LegalPrivacy"
}
</script>

<style scoped></style>
